import LRU from 'lru-cache';

const cache = new LRU({
  max: 500,
  // length: function (n, key) {
  //   return n * 2 + key.length;
  // },
  maxAge: 1000 * 60 * 60
});

export default cache;
